import * as yup from "yup";

export const BILLING_STATUS = {
  ABERTO: "A",
  ATRASADO: "T",
  PAGO: "P",
  CANCELADO: "C",
  PENDENTES: "D",
};

export const findBillingStatus = (status) => {
  switch (status) {
    case BILLING_STATUS.ABERTO:
      return "Aberto";
    case BILLING_STATUS.ATRASADO:
      return "Atrasado";
    case BILLING_STATUS.PAGO:
      return "Pago";
    case BILLING_STATUS.CANCELADO:
      return "Cancelado";
    case BILLING_STATUS.PENDENTES:
      return "Pendente";
    case "R": // conta parcelada (a API esconde das listas)
      return "Parcelada";
    default:
      return "";
  }
};

export const yupSchema = yup.object().shape({
  numPedido: yup.string(),
  partidaContabil: yup.string().required("Esse campo é obrigatório"),
  supplier: yup.string().required("Esse campo é obrigatório"),
  descricao: yup.string().required("Esse campo é obrigatório"),
  paymentMethod: yup.string().required("Esse campo é obrigatório"),
  dataPedido: yup.date().nullable(),
  dataVencimento: yup.date().nullable(),
  dataPagamento: yup
    .date()
    .nullable()
    .when("status", {
      is: BILLING_STATUS.PAGO,
      then: (schema) =>
        schema.required(
          "Data de pagamento é obrigatória quando o status é Pago"
        ),
    }),
  valor: yup
    .string()
    .required("Esse campo é obrigatório")
    .when("status", {
      is: BILLING_STATUS.PAGO,
      then: (schema) =>
        schema.test(
          "valor-maior-zero",
          "Valor deve ser maior que zero quando o status é Pago",
          (value) => {
            if (!value) return false;
            const numericValue = parseFloat(
              value.replace(/[^\d,.-]/g, "").replace(",", ".")
            );
            return numericValue > 0;
          }
        ),
    }),
  status: yup.string().required("Esse campo é obrigatório"),
  observacoes: yup.string(),
  account: yup
    .string()
    .nullable()
    .when("status", {
      is: BILLING_STATUS.PAGO,
      then: (schema) =>
        schema.required("Conta bancária é obrigatória quando o status é Pago"),
    }),
  accountGroup: yup.string().required("Esse campo é obrigatório"),
  accountSubGroup: yup.string().required("Esse campo é obrigatório"),
});

export const initialValues = {
  purchase: "",
  numPedido: "",
  descricao: "",
  supplier: null,
  shippingCompany: "",
  paymentMethod: null,
  dataPedido: null,
  dataVencimento: null,
  dataPagamento: null,
  valor: 0,
  status: "",
  account: null,
  observacoes: "",
  partidaContabil: null,
  accountGroup: null,
  accountSubGroup: null,
  todasGenesis: null,
  fromNfe: null,
};
